import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { UtilsService } from '@shared/services/utils/utils.service';
import { maxLenghtValidator } from '@shared/validators/max-length.validator';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { FormName } from 'src/app/core/interfaces/form-name.interface';
import { ListaAseguradosAdicionalesInterface, ListaGarantiasInterface, TomadorPresupuestoInterface } from 'src/app/core/interfaces/presupuesto-guardar.interface';

import { DocumentacionCorreoService } from 'src/app/core/providers/services/documentacion-correo/documentacion-correo.service';
import { Numbers } from 'src/app/utils/constants';

export default class LegalStepThreeRentComponentUtils {

  /**
   * constructor
   * @param utilsSrv utilsSrv
   * @param emailSrv emailSrv
   */
  constructor(private utilsSrv: UtilsService, private readonly emailSrv: DocumentacionCorreoService) {
    this.utilsSrv = utilsSrv;
    this.emailSrv = emailSrv;
  }

  public formDataUtils: FormGroup;
  public displayErrorTerms: boolean;
  public showModalT = false;
  public displayModal: boolean;
  public showModal = false;
  public stepActive = '4';
  public showThanks = false;

  /**
   * setValidator
   * @param formData formData
   * @param ownerConfig ownerConfig
   * @param inmuebleConfig inmuebleConfig
   * @param tenantConfig tenantConfig
   * @param formConfig formConfig
   * @param patternCP patternCP
   * @param patternEmail patternEmail
   */
  public setValidator(formData: any, ownerConfig: any, inmuebleConfig: any,
                      tenantConfig: any, formConfig: any, patternCP: any, patternEmail: any): void {
    this.formDataUtils = formData;
    // Propietario
    this.formDataUtils.get(ownerConfig.documentType.linkFormPath).setValidators([
      Validators.required]);
    this.formDataUtils.get(ownerConfig.documentNumber.linkFormPath).setValidators([
      maxLenghtValidator(Numbers.number15), Validators.required]);
    this.formDataUtils.get(ownerConfig.name.linkFormPath).setValidators([Validators.required]);
    this.formDataUtils.get(ownerConfig.firstSurname.linkFormPath).setValidators([Validators.required]);
    this.formDataUtils.get(ownerConfig.email.linkFormPath).setValidators([Validators.pattern(patternEmail)]);
    this.formDataUtils.get(ownerConfig.documentType.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(ownerConfig.documentNumber.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(ownerConfig.name.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(ownerConfig.firstSurname.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(ownerConfig.email.linkFormPath).updateValueAndValidity();

    // Inmueble
    this.formDataUtils.get(inmuebleConfig.direction.linkFormPath).setValidators([Validators.required]);
    this.formDataUtils.get(inmuebleConfig.postalCode.linkFormPath).
      setValidators([Validators.pattern(patternCP), Validators.required]);
    this.formDataUtils.get(inmuebleConfig.direction.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(inmuebleConfig.postalCode.linkFormPath).updateValueAndValidity();

    // Inquilino
    this.formDataUtils.get(tenantConfig.documentType.linkFormPath).setValidators([Validators.required]);
    this.formDataUtils.get(tenantConfig.documentNumber.linkFormPath)
    .setValidators([maxLenghtValidator(Numbers.number15), Validators.required]);
    this.formDataUtils.get(tenantConfig.name.linkFormPath).setValidators([Validators.required]);
    this.formDataUtils.get(tenantConfig.firstSurname.linkFormPath).setValidators([Validators.required]);
    this.formDataUtils.get(tenantConfig.documentType.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(tenantConfig.documentNumber.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(tenantConfig.name.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(tenantConfig.firstSurname.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.domiciliation.acceptIban.linkFormPath).setValidators([Validators.required]);
    this.formDataUtils.get(formConfig.domiciliation.acceptTerms.linkFormPath).setValidators([Validators.required]);
    this.formDataUtils.get(formConfig.domiciliation.treatmentOfData.linkFormPath).setValidators([this.validTreatment]);
    this.formDataUtils.get(formConfig.domiciliation.acceptIban.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.domiciliation.acceptTerms.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.domiciliation.treatmentOfData.linkFormPath).updateValueAndValidity();
  }

  /**
   * Validate if the treatment of data is marked
   * @param control control treatment
   * @returns validationError
   */
  public validTreatment(control: FormControl): ValidationErrors {
    let validationErrors: ValidationErrors = null;
    if (control.value[0].Aceptacion === '0') {
      validationErrors = { opcionInvalida: true };
    }
    return validationErrors;
  }

  /**
   * removeValidator
   * @param formData formData
   * @param ownerConfig ownerConfig
   * @param inmuebleConfig inmuebleConfig
   * @param tenantConfig tenantConfig
   * @param formConfig formConfig
   */
  public removeValidator(formData: any, ownerConfig: any, inmuebleConfig: any, tenantConfig: any, formConfig: any): void {
    this.formDataUtils = formData;
    // Propietario
    this.formDataUtils.get(ownerConfig.documentType.linkFormPath).clearValidators();
    this.formDataUtils.get(ownerConfig.documentNumber.linkFormPath).clearValidators();
    this.formDataUtils.get(ownerConfig.name.linkFormPath).clearValidators();
    this.formDataUtils.get(ownerConfig.firstSurname.linkFormPath).clearValidators();
    this.formDataUtils.get(ownerConfig.email.linkFormPath).clearValidators();
    this.formDataUtils.get(ownerConfig.documentType.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(ownerConfig.documentNumber.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(ownerConfig.name.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(ownerConfig.firstSurname.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(ownerConfig.email.linkFormPath).updateValueAndValidity();

    // Inmueble
    this.formDataUtils.get(inmuebleConfig.direction.linkFormPath).clearValidators();
    this.formDataUtils.get(inmuebleConfig.postalCode.linkFormPath).clearValidators();
    this.formDataUtils.get(inmuebleConfig.direction.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(inmuebleConfig.postalCode.linkFormPath).updateValueAndValidity();

    // Inquilino
    this.formDataUtils.get(tenantConfig.documentType.linkFormPath).clearValidators();
    this.formDataUtils.get(tenantConfig.documentNumber.linkFormPath).clearValidators();
    this.formDataUtils.get(tenantConfig.name.linkFormPath).clearValidators();
    this.formDataUtils.get(tenantConfig.firstSurname.linkFormPath).clearValidators();
    this.formDataUtils.get(tenantConfig.documentType.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(tenantConfig.documentNumber.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(tenantConfig.name.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(tenantConfig.firstSurname.linkFormPath).updateValueAndValidity();

    this.formDataUtils.get(formConfig.domiciliation.acceptIban.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.domiciliation.treatmentOfData.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.domiciliation.acceptIban.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.domiciliation.acceptTerms.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.domiciliation.treatmentOfData.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.domiciliation.iban.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.domiciliation.swift.linkFormPath).clearValidators();
    this.formDataUtils.get(formConfig.domiciliation.acceptTerms.linkFormPath).updateValueAndValidity();
    this.formDataUtils.get(formConfig.domiciliation.iban.linkFormPath).updateValueAndValidity();
  }

  /**
   * getCoverageType
   * @returns returns
   */
  getCoverageType(): string {
    const auxTypeCob = 'Anual_+90';
    return auxTypeCob;
  }

  /**
   * consentimientosPresu
   * @param formDataValue formDataValue
   * @returns returns
   */
  consentimientosPresu(formDataValue: any): {idTipoConsentimiento: number; aceptacion: number}[] {
    const listado: {idTipoConsentimiento: number; aceptacion: number}[] = [
      {
        idTipoConsentimiento: Numbers.number1,
        aceptacion: parseInt(formDataValue.termsList[Numbers.number0].Aceptacion, Numbers.number10)
      },
      {
        idTipoConsentimiento: Numbers.number15,
        aceptacion: parseInt(formDataValue.termsList[Numbers.number1].Aceptacion, Numbers.number10)
      },
      {
        idTipoConsentimiento: Numbers.number9,
        aceptacion: parseInt(formDataValue.termsList[Numbers.number2].Aceptacion, Numbers.number10)
      },
      {
        idTipoConsentimiento: Numbers.number16,
        aceptacion: parseInt(formDataValue.termsList[Numbers.number3].Aceptacion, Numbers.number10)
      }
    ];

    return listado;
  }

  /**
   * aditionalPres
   * @param formDataValue formDataValue
   * @returns returns
   */
  aditionalPres(formDataValue: any): ListaAseguradosAdicionalesInterface[] {
    const dateToday: string = this.utilsSrv.getDateToday();
    const aditionalPres: ListaAseguradosAdicionalesInterface[] = [
      {
        idAsegurado: 0,
        nombreAsegurado: formDataValue.insuredListData.owner.name,
        apellido1Asegurado: formDataValue.insuredListData.owner.firstSurname,
        apellido2Asegurado: formDataValue.insuredListData.owner.secondSurname,
        nifAsegurado: formDataValue.insuredListData.owner.documentNumber,
        fechaNacimientoAsegurado: '2000-01-01',
        ambitoOrigen: formDataValue.countryOriginEnvironment,
        ambitoDestino: formDataValue.countryDestinyEnvironment || formDataValue.countryDestinyEnvironment,
        tipoCoberturaAsegurado: this.getCoverageType(),
        fecEfecto: this.utilsSrv.changeDateOrderToService(formDataValue.dateStart),
        fecVencimiento: this.utilsSrv.changeDateOrderToService(formDataValue.dateEnd),
        idSobrePrimaAsegurado: 0,
        desDescuento: formDataValue.codePromotional,
        email: formDataValue.insuredListData.owner.email,
        idTipoDescuento: 0,
        fecTarificacion: dateToday,
        idPoliza: '0'
      }
    ];

    return aditionalPres;
  }

  /**
   * tomadorPres
   * @param formDataValue formDataValue
   * @returns returns
   */
  tomadorPres(formDataValue: any): TomadorPresupuestoInterface[] {
    const auxIdSector = 19130;
    const insuredChoosed: any = formDataValue.insuredData.typeOwner;
    let razonSocial = '';
    let ape1 = '';
    let ape2 = '';
    const valSocial: any = formDataValue.insuredData.bussines.direction;
    if (insuredChoosed === 'Empresa' && formDataValue.insuredData.documentType.name === 'CIF') {
      razonSocial = valSocial;
      if (valSocial === '' || valSocial === undefined) { razonSocial = ''; }
      ape1 = '';
      ape2 = '';
    } else {
      razonSocial = valSocial;
      if (valSocial === '' || valSocial === undefined) { razonSocial = formDataValue.insuredData.particular.name; }
      ape1 = formDataValue.insuredData.firstSurname;
      ape2 = formDataValue.insuredData.secondSurname;
    }
    let idSector: number = auxIdSector;
    if (insuredChoosed === 'Empresa') { idSector = formDataValue.insuredData.bussines.companySector.id; }
    let indCif = 0;
    // 1 NIF => 2 CIF => 3 NIE => 4 pas
    if (formDataValue.insuredData.documentType.name === 'CIF') { indCif = 1; }
    let cif = '';
    if (formDataValue.insuredData.documentType.name !== 'Pasaporte') { cif = formDataValue.insuredData.documentNumber; }
    let pasaporte = '';
    if (formDataValue.insuredData.documentType.name === 'Pasaporte') { pasaporte = formDataValue.insuredData.documentNumber; }
    const separarPrefijo: any = formDataValue.insuredData.prefix.split('(');
    const prefijo: any = separarPrefijo[1].split(')');
    const tomadorPresupuesto: TomadorPresupuestoInterface[] = [
      {
        Id_Presupuesto: 0,
        nombreRazonSocial: razonSocial,
        documento: cif,
        tipoDocumento: formDataValue.insuredData.documentType.name,
        apellido1: ape1,
        apellido2: ape2,
        direccion: formDataValue.insuredData.direction,
        idMunicipio: formDataValue.insuredData.municipality.id,
        municipio: formDataValue.insuredData.municipality.name,
        telDomicilio: '',
        telMovil: prefijo[0] + formDataValue.insuredData.telephone,
        telTrabajo: '',
        fax: '',
        emailTomador: formDataValue.insuredData.email,
        indDomiciliar: 1,
        idViaPago: Numbers.number20,
        entidad: '',
        sucursal: '',
        DC: '',
        cuenta: '',
        idCliente: 0,
        iban: formDataValue.domiciliation.iban,
        swift: formDataValue.domiciliation.swift,
        cp: formDataValue.insuredData.postalCode,
        idProvincia: formDataValue.insuredData.provinceId,
        provincia: formDataValue.insuredData.province,
        pais: formDataValue.insuredData.country.name,
        idSector,
        indCif,
        CIF: cif, // numero de documento
        Pasaporte: pasaporte,
        idCcc: 0
      }
    ];

    return tomadorPresupuesto;
  }

  /**
   * datalayer
   * @param id id
   * @param price price
   * @param formData formData
   * @param gtmService gtmService
   */
  datalayer(id: number, price: number, formData: FormGroup, gtmService: GoogleTagManagerService): void {
    const formName: FormName = this.getFormData(formData);
    const formNameS = 'seguro de asistencia ' + formName.layerName;
    const actionField: any = {
      id: id.toString(),
      affiliation: 'Banco',
      revenue: (price.toFixed(Numbers.number2)).toString(),
      tax: '-'
    };
    const productLayer: any = {
      name: formNameS,
      id: id.toString(),
      price: (price.toFixed(Numbers.number2)).toString(),
      brand: formName.layerName,
      category: 'jurídico',
      variant: '-',
      quantity: 1,
      list: 'contrata_online'
    };
    const datalayerD: any = {
      event: 'ev_addToCart',
      ecommerce: {
        currencyCode: 'EUR',
        add: {
          products: [productLayer]
        }
      }
    };
    localStorage.removeItem('layer1');
    localStorage.removeItem('layer2');
    localStorage.setItem('layer1', JSON.stringify(actionField));
    localStorage.setItem('layer2', JSON.stringify(productLayer));
    gtmService.pushTag(datalayerD);
  }

  /**
   * datalayer2
   * @param formData formData
   * @param gtmService gtmService
   */
  datalayer2(formData: any, gtmService: any): void {
    const formName: any = this.getFormData(formData);
    const datalayerD: any = {
      event: 'ev_tarificacion',
      event_category: 'tarificacion',
      event_action: formName.layerName,
      event_label: 'gestion_de_polizas',
      categoria_seguro: 'jurídico',
      paso: 't3'
    };
    gtmService.pushTag(datalayerD);
  }

  /**
   * showModalTerms
   */
  showModalTerms(): void {
    this.displayErrorTerms = true;
    this.showModalT = this.displayErrorTerms;
  }

  /**
   * showModalDialog
   */
  showModalDialog(): void {
    this.displayModal = true;
    this.showModal = this.displayModal;
  }

  /**
   * setStepThanks
   */
  setStepThanks(): void {
    this.stepActive = localStorage.getItem('stepThanks');

    if (this.stepActive !== '' && this.stepActive !== null) {
      this.showThanks = true;
    }
  }

  /**
   * getGarantees
   * @param formDataValue formDataValue
   * @returns returns
   */
  getGarantees(formDataValue: any): ListaGarantiasInterface[] {
    const garantees: any = formDataValue.guaranteeSelectionList;
    const garanteesList: ListaGarantiasInterface[] = garantees.map((el: any) => {
      return {
        ...el,
        Id_Producto: formDataValue.guaranteeLimitOfMedicalExpenses.idProducto,
        idAmbito: formDataValue.countryDestinyEnvironment
      };
    });
    return garanteesList;
  }

  /**
   * getFormData
   * @param formData formData
   * @returns returns
   */
  getFormData(formData: FormGroup): FormName {
    return formData.get('insureSelected').value;
  }
}
